import config from "constants/config";
import React, { createContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";

export const SocketContext = createContext();

const SocketContextProvider = ({ children }) => {
    const business = useSelector((state) => state?.business);

      const socketContextValue = useMemo(() => {
          if (business) {
              const url = `${config.API_URL}/message`;
              const socket = io(url, {
                  extraHeaders: {
                      "x-business-id": business?._id,
                  },
                  autoConnect: true,
              });

              return { socket };
          }
      }, [business?._id]);


    return (
        <SocketContext.Provider value={ socketContextValue}>
            {children}
        </SocketContext.Provider>
    );
};

export default SocketContextProvider;
